module.exports = __webpack_public_path__ + "4f37ff15fb2dcff984a41b2666a965e1.png";